import { render, staticRenderFns } from "./LottoRatePerUser.vue?vue&type=template&id=0980191a&scoped=true&"
import script from "./LottoRatePerUser.vue?vue&type=script&lang=js&"
export * from "./LottoRatePerUser.vue?vue&type=script&lang=js&"
import style0 from "./LottoRatePerUser.vue?vue&type=style&index=0&id=0980191a&lang=scss&scoped=true&"
import style1 from "./LottoRatePerUser.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0980191a",
  null
  
)

export default component.exports